module.exports = __webpack_public_path__ + "img/yifuvx.2b5cabd6.jpg";